import { render } from "./SFJC.vue?vue&type=template&id=61075ce1&scoped=true"
import script from "./SFJC.vue?vue&type=script&lang=js"
export * from "./SFJC.vue?vue&type=script&lang=js"

import "./SFJC.vue?vue&type=style&index=0&id=61075ce1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61075ce1"]])

export default __exports__